import { request } from "./client"

export const fetchCurrentUser = async () => (await request("GET", "/auth/me")).user
export const signIn = async (email, password) => (await request("POST", "/auth/login", { email, password })).user
export const signUp = async (email, password, name) => (await request("POST", "/auth/register", { email, password, name })).user
export const signOut = () => request("POST", "/auth/logout", {})

// Admin only: create a login and its profile in one step / remove both.
export const createStaffUser = async ({ email, password, name, phone, role = "tech" }) =>
  (await request("POST", "/admin/users", { email, password, name, phone, role })).user
export const deleteUser = (uid) => request("DELETE", `/admin/users/${encodeURIComponent(uid)}`)
